import { z } from 'zod';

export const BrandedCampaignId = z.string();

export type BrandedCampaignId = z.infer<typeof BrandedCampaignId>;
